import {Repository} from "./Repository";
import {AxiosInstance} from "axios";
import { UserProfile } from "@api/models/UserProfile";

export class AuthRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    login(username: string, password: string) {
        return this.client.post('login', {
            username,
            password,
            generateRefreshToken: true
        })
        .then(({data}) => data);
    }

    loginByCode(code: string) {
        return this.client.post('login/loginByCode', {
            code
        })
        .then(({data}) => data);
    }

    loginAnonymous(profile: UserProfile) {
        return this.client.post('v2/login/anonymous', { profile: profile }).then(({ data }) => data);
    }
}